export const tr = {
    news: 'Haberler'
};
